var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"basicInfo",staticClass:"acout"},[(_vm.typeIndex == 1)?_c('HomeIndex',{on:{"updateType":_vm.updateType}}):(_vm.typeIndex == 2)?_c('ChangeRecord',{on:{"updateType":_vm.updateType}}):(_vm.typeIndex == 3)?_c('Recharge',{on:{"updateType":_vm.updateType}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }